import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { TranslateState } from '../../types';
import { TranslateModel } from '../translate-model';

function createTranslateState(): TranslateState {
    return {
        title: '',
        result: [],
        updatedAt: '',
        editingOriginalIdx: -1,
        editingTranslationIdx: -1,
        isLoadingTranslateResult: false,
        isLoadingRegenerateTranslateFragment: false,
        waitingFirstResponse: false,
        currentTranslateFragmentIndex: -1,
    };
}

@injectable()
export class AITranslationModelImpl extends AbstractModel<TranslateState> implements TranslateModel {
    protected _modelData: TranslateState = createTranslateState();

    public dispose() {
        this.update(() => {
            return createTranslateState();
        });
    }
}
